import { useState, useEffect } from 'react';
import { loadDemoUsers } from '../demo/demoData';

function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await loadDemoUsers();
        setUsers(Array.isArray(data) ? data : []);
      } catch (err) {
        setError('Failed to fetch users: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return { users, loading, error };
}

export default useUsers; 